export const GlassesDetailImages = [
  {
    id: "se2-detail",
    src: "https://res.cloudinary.com/dtkdsevtm/image/upload/v1605201286/images/se2-detail_yjqquq.jpg",
    alt: "Chi Tiết của Kính bảo hộ SE2 từ Mỹ | Chống xước, Chống Đọng Nước và Chống Va Đập",
  },
];
